<div class="container" id="salesReceiptPreview" style="display: none">
        <table width="100%" border="0" cellpadding="0" align="center">
            <tr style="border-bottom: 4px solid var(--primary-color)">
                <td style="width: 40%; padding-bottom: 5px">
                    <div style="font-weight: bold; font-size: 15px; margin-bottom: 10px">Sales Receipt- {{ rpoNumber }}</div>
                    <div *ngIf="savedBill && savedBill?.number">
                        <ngx-barcode6 [bc-element-type]="elementType" [bc-value]="detailsData?.number" [bc-format]="format" [bc-line-color]="lineColor" [bc-width]="width" [bc-height]="height" [bc-display-value]="displayValue" [bc-font-options]="fontOptions" [bc-font]="font" [bc-text-align]="textAlign" [bc-text-position]="textPosition" [bc-text-margin]="textMargin" [bc-font-size]="fontSize" [bc-background]="background" [bc-margin]="margin" [bc-margin-top]="marginTop" [bc-margin-bottom]="marginBottom" [bc-margin-left]="marginLeft" [bc-margin-right]="marginRight"> </ngx-barcode6>
                    </div>
                </td>
                <td style="width: 25%; height: 50px; padding-bottom: 10px" *ngIf="app && app.appLogo"> 
                    <img style="width: auto; height: auto; max-width: 90px; max-height: 45px" [src]="app.appLogo" alt="logo" />
                <td style="padding-bottom: 15px;width: 35%;">
                    <div style="font-weight: bold; font-size: 12px">{{ app?.organizationData?.name }}</div>
                    <div style="font-size: 8px; color: #888">{{ companyInfo?.address || "" }}</div>
                    <div style="font-size: 8px; color: #888">{{ companyInfo?.state || "" }} {{ companyInfo?.state ? "," : "" }} {{ companyInfo?.city || "" }} {{ companyInfo?.city ? "," : "" }} {{ companyInfo?.country || "" }} {{ companyInfo?.country && companyInfo?.zip ? "," : "" }} {{ companyInfo?.zip || "" }}</div>
                    <div style="font-size: 8px; color: #888">{{ companyInfo?.phone || "" }}</div>
                    <div style="font-size: 8px; color: #888">{{ companyInfo?.emailId || "" }}</div>
                </td>
            </tr>
      <!-- Account Information Section -->
      <tr>
          <td colspan="3">
              <table width="100%" border="0" cellpadding="0" style="border-collapse: collapse">
                  <tr>
                      <td style="padding: 5px 5px 5px 0; border-bottom: 1px solid #ddd; vertical-align: top" [attr.colspan]="1" [ngStyle]="{ width: '50%' }">
                          <div style="font-weight: bold; font-size: 13px; margin-bottom: 5px">Account Information</div>
                          <ng-container *ngFor="let item of accountinfo; let i = index">
                              <div *ngIf="i < accountinfo.length / 2" style="font-size: 10px; margin-bottom: 2px; margin-left: 2px">
                                  <strong>{{ item.header }}:</strong>
                                  <ng-container *ngIf="item.datatype === 'DateTime'; else normalValue">
                                      {{ item.value | date: "dd/MM/yyyy" }}
                                  </ng-container>
                                  <ng-template #normalValue>
                                      {{ item.value }}
                                  </ng-template>
                              </div>
                          </ng-container>
                      </td>
                      <td style="border-bottom: 1px solid #ddd; border-left: 1px solid #ddd; padding: 5px 0 5px 5px; vertical-align: top; width: 50%">
                          <ng-container *ngFor="let item of accountinfo; let i = index">
                              <div *ngIf="i >= accountinfo.length / 2" style="font-size: 10px; margin-bottom: 2px; margin-left: 2px">
                                  <strong>{{ item.header }}:</strong>
                                  <ng-container *ngIf="item.datatype === 'DateTime'; else normalValueRight">
                                      {{ item.value | date: "dd/MM/yyyy" }}
                                  </ng-container>
                                  <ng-template #normalValueRight>
                                      {{ item.value }}
                                  </ng-template>
                              </div>
                          </ng-container>
                      </td>
                  </tr>
              </table>
          </td>
      </tr>

      <!-- Invoice Table Section -->
      <tr>
          <td colspan="3" style="padding-top: 20px">
              <table cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[0]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">
                          {{ salesReceiptsTemplate?.labels_table[0]?.labelname }}
                      </th>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[1]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[1]?.labelname }}</th>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[2]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[2]?.labelname }}</th>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[3]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[3]?.labelname }}</th>
                      <!-- <th *ngIf="salesReceiptsTemplate?.labels_table[4]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[4]?.labelname }}</th> -->
                      <th style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">Credit</th>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[5]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">
                          {{ salesReceiptsTemplate?.labels_table[5]?.labelname }}
                      </th>
                      <th *ngIf="salesReceiptsTemplate?.labels_table[6]?.IsPrint" style="font-weight: bold; padding: 8px; text-align: left; background: #ce1800; color: white; font-size: 11px">
                          {{ salesReceiptsTemplate?.labels_table[6]?.labelname }}
                      </th>
                  </tr>

                  <!-- Invoice Rows -->
                  <tr *ngFor="let product of InvoiceTB">
                      <td *ngIf="salesReceiptsTemplate?.labels_table[0]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.dueDate | date: "MM/dd/yyyy" }}
                      </td>
                      <td *ngIf="salesReceiptsTemplate?.labels_table[1]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.invoiceNo ? product.invoiceNo : null }}
                      </td>
                      <td *ngIf="salesReceiptsTemplate?.labels_table[2]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.invoiceAmount ? (product.invoiceAmount | customNumberFormat: fractionDigits | currencySymbol) : null }}
                      </td>
                      <td *ngIf="salesReceiptsTemplate?.labels_table[3]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">{{ product?.currencyCode ?? this.baseCurrency?.symbol }}{{ (product.invoiceAmount || 0) * (product.exchangeRate || 1) | customNumberFormat: fractionDigits }}</td>
                      <!-- <td *ngIf="salesReceiptsTemplate?.labels_table[4]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.actualDueAmount ? (product.actualDueAmount | customNumberFormat: fractionDigits | currencySymbol) : null }}
                      </td> -->
                      <td style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.credit | customNumberFormat: fractionDigits | currencySymbol }}
                      </td>
                      <td *ngIf="salesReceiptsTemplate?.labels_table[5]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.amountApplied | customNumberFormat: fractionDigits | currencySymbol }}
                      </td>
                      <td *ngIf="salesReceiptsTemplate?.labels_table[6]?.IsPrint" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px">
                          {{ product.amountDue | customNumberFormat: fractionDigits | currencySymbol }}
                      </td>
                  </tr>

                  <!-- Empty Rows -->
                  <ng-container *ngFor="let i of [7, 6, 5, 4, 3, 2, 1]; let isEven = even">
                      <tr *ngIf="InvoiceTB?.length < i">
                          <td *ngFor="let j of [0, 1, 2, 3, 4, 5, 6, 7]" style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 11px; height: 20px" [ngStyle]="{ background: isEven ? '#e0e0e0' : 'transparent' }"></td>
                      </tr>
                  </ng-container>
              </table>
          </td>
      </tr>

      <!-- Footer Section -->
      <tr>
          <td colspan="3" style="padding-top: 20px">
              <table cellpadding="0" cellspacing="0" style="float: right; page-break-inside: avoid">
                  <tr>
                      <th style="text-align: left; padding-right: 25px; text-transform: uppercase; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px">
                          {{ salesReceiptsTemplate?.labels_footer?.[0]?.labelname }}
                      </th>
                      <td style="text-align: right; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px; font-family: Roboto-Regular">
                          {{ savedBill?.subTotal | customNumberFormat: fractionDigits | currencySymbol }}
                      </td>
                  </tr>
                  <tr *ngIf="salesReceiptsTemplate?.labels_footer?.[2]?.IsPrint">
                      <th style="text-align: left; padding-right: 25px; text-transform: uppercase; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px">
                          {{ salesReceiptsTemplate?.labels_footer?.[1]?.labelname }}
                      </th>
                      <td style="text-align: right; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px; font-family: Roboto-Regular">
                          {{ savedBill?.discountAmount | customNumberFormat: fractionDigits | currencySymbol }}
                      </td>
                  </tr>
                  <tr *ngIf="salesReceiptsTemplate?.labels_footer?.[1]?.IsPrint && savedBill?.discountAmount > 0">
                      <th style="text-align: left; padding-right: 25px; text-transform: uppercase; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px">
                          {{ salesReceiptsTemplate?.labels_footer?.[2]?.labelname }}
                      </th>
                      <td style="text-align: right; padding: 3px; font-weight: bold; min-width: 100px; color: #999; font-size: 10px; font-family: Roboto-Regular">
                          {{ savedBill?.discountAccount }}
                      </td>
                  </tr>
              </table>
          </td>
      </tr>

      <!-- Memo Section -->
      <tr style="border-top: 4px solid #ce1800">
          <td colspan="3">
              <table cellpadding="0" cellspacing="0" width="100%">
                  <tr *ngIf="salesReceiptsTemplate?.labels_message?.[0]?.IsPrint && savedBill?.billPaymentNotes?.[savedBill?.billPaymentNotes?.length - 1]?.note?.comment">
                      <th style="font-size: 10px; text-align: left; padding-top: 10px; padding-bottom: 3px; width: 100px">Memo:</th>
                      <td style="font-size: 10px; text-align: left; padding-top: 10px; padding-bottom: 3px">
                          <span [innerHTML]="savedBill?.billPaymentNotes[savedBill?.billPaymentNotes?.length - 1]?.note?.comment ?? ''"></span>
                      </td>
                  </tr>
              </table>
          </td>
      </tr>
  </table>

  <!-- Custom Attributes Section -->
  <div class="p-grid" style="padding-top: 15px;">
      <ng-container *ngFor="let section of ['misc_item', 'other1_item', 'other2_item', 'other3_item']">
          <div class="p-col-12" *ngIf="customAtributes?.[section]?.length" [ngClass]="{ 'p-mt-0 p-pt-0': section !== 'misc_item' }">
              <div class="card" style="min-height: auto; padding: 5px">
                  <p style="font-weight: 600; color: #2c2c2c; margin: 0 0 4px 0">{{ customAtributes[section][0]?.section?.name }}:</p>
                  <div class="custom-attribute-container" style="display: flex; flex-direction: column; gap: 2px">
                      <div *ngFor="let item of customAtributes[section]" style="display: flex; align-items: flex-start">
                          <div style="min-width: 120px; max-width: 120px">
                              <span style="font-weight: 500; word-wrap: break-word">{{ item.name }}:</span>
                          </div>
                          <div style="flex: 1">
                              <span style="word-wrap: break-word">{{ item.value }}</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </ng-container>
  </div>
</div>
